import { type Moment } from 'moment';

import type { EventFormData } from '../data-utils';

export enum ShiftDirection {
	Up = 1,
	Down = -1,
	None = 0
}

export type EditShiftDirectionProps = {
	originalStart: Moment;
	originalEnd: Moment;
	editedStart: Moment;
	editedEnd: Moment;
};

export type RangeRecord = {
	effectiveStartDate: Moment;
	effectiveEndDate: Moment;
	daysOfWeek: number[];
	formData?: EventFormData;
	adjustEffectiveDates?: boolean;
};

export type RangeProcessingData = {
	effectiveStartDate: Moment;
	effectiveEndDate: Moment;
};
